import { createFileRoute } from '@tanstack/react-router';
import { ReconciliationResults } from '../../../features/money-boundary/components/ReconciliationResults';
import { usePageTitle } from '../../../lib/hooks.js';
import { PageHeader } from '../../../components/layout/PageHeader';

export const Route = createFileRoute('/_auth/reconciliation/$importId')({
  component: ReconciliationDetail,
});

function ReconciliationDetail() {
  usePageTitle('Reconciliation Detail');
  const { importId } = Route.useParams();

  return (
    <div>
      <PageHeader title="Reconciliation Detail" backTo="/" />
      <ReconciliationResults importId={importId} />
    </div>
  );
}
